export enum ConjunctionEnum {
  Unknown,
  And,
  Or
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/models/conjunction.enum.ts